import { TextField } from '@mui/material';

type SalesTaxNumberInputProps = {
  value: string | null;
  onChange: (value: string | null) => void;
};

export function SalesTaxNumberInput({
  value,
  onChange,
}: SalesTaxNumberInputProps) {
  return (
    <TextField
      type='text'
      label='Umsatzsteuer-ID'
      size='small'
      value={value || ''}
      onChange={event =>
        onChange(event.target.value !== '' ? event.target.value : null)
      }
      fullWidth
    />
  );
}
